(function searchwidgetScript($, Drupal) {
  Drupal.behaviors.searchwidget = {
    attach(context) {
      var $searchWidgetForm = $('.search-widget__form');
      $searchWidgetForm.each(function() {
        var $searchWidgetAction = $(this).attr('action');
        $(this).submit(function(event) {
          event.preventDefault();
          $searchWidgetAction = $searchWidgetAction + '?keywords=' + $(this).find('.search-widget__form-item--input').val().replace(' ', '+');
          window.location.replace($searchWidgetAction);
        });
      });
    },
  };
}(jQuery, Drupal));